import { AbstractControl, ValidatorFn } from "@angular/forms";

const RegexValidations = {
  idNumber: /^[1-2]\d{9}$/i,
  landlineNumber: /^2[1-6]\d{6}$/,
  mobileNumber: /^((\+|00)?968)?[279]\d{7}$/,
  multipleMobileNumbers: /^(((\+|00)?968)?[279]\d{7})(,\s*((\+|00)?968)?[279]\d{7})*$/,
  charactersOnly: /^[a-zA-Z\u0600-\u06FF\s]+$/,
  email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  multipleEmails: /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})(,\s*[\w-\.]+@([\w-]+\.)+[\w-]{2,4}) *$/,
  arabicCharactersOnly: /^[\u0621-\u064A\u064B-\u0652\u0660-\u0669،/\-_() 0-9\n]+$/i,
  englishCharactersOnly: /^[a-zA-Z0-9\u0100-\u017E !@#$%^’&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/u,
  positiveDecimal: /^(?!-)[0-9]+(\.[0-9]+)?$/,
};

export const customValidations = {
  idNumber: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;

      if (!value) return null;

      if (!RegexValidations.idNumber.test(value)) {
        return { id_number: true };
      }

      return null;
    };
  },
  email: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;

      if (!value) return null;

      if (!RegexValidations.email.test(value) && value) {
        return { email: true };
      }

      return null;
    };
  },
  multipleEmails: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;

      if (!value) return null;

      if (RegexValidations.email.test(value)) return null;

      if (!RegexValidations.multipleEmails.test(value)) {
        return { multipleEmails: true };
      }

      return null;
    };
  },
  mobileNumber: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;

      if (!value) return null;

      if (!RegexValidations.mobileNumber.test(value)) {
        return { invalid_mobile_number: true };
      }

      return null;
    };
  },
  multipleMobileNumbers: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;

      if (!value) return null;

      if (!RegexValidations.multipleMobileNumbers.test(value)) {
        return { invalid_mobile_number: true };
      }

      return null;
    };
  },
  charactersOnly: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;

      if (!value) return null;

      if (!RegexValidations.charactersOnly.test(value)) {
        return { characters_only: true };
      }

      return null;
    };
  },
  arabicCharactersOnly: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;

      if (!value) return null;

      if (!RegexValidations.arabicCharactersOnly.test(value)) {
        return { arabic_characters_only: true };
      }

      return null;
    };
  },
  englishCharactersOnly: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = control.value;

      if (!value) return null;

      if (!RegexValidations.englishCharactersOnly.test(value)) {
        return { english_characters_only: true };
      }

      return null;
    };
  },
  positiveDecimalNumbersOnly: (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      if (!value) return null;

      if (!RegexValidations.positiveDecimal.test(value)) {
        return { positive_decimal: true };
      }
      return null;
    };
  },
  withCustomMobileNumberRegex: (regex: RegExp | string): ValidatorFn => {
    const regexPattern = regex instanceof RegExp ? regex : new RegExp(regex);
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const value = Number(control.value);
      if (!value) return null;

      if (!regexPattern.test(`${value}`)) return { invalid_mobile_number: true };

      return null;
    };
  },
};
